import { apiClient } from '@shared/utils/api-client';
import { compressImageFiles } from '@shared/utils/compress-image';
import type {
  ClientOrderChatMessage,
  ClientOrderChatMessagesResponse,
  ClientOrderChatSessionsResponse,
} from '../types';

export const CLIENT_ORDER_CHAT_MAX_IMAGES = 5;

export const clientOrderChatApi = {
  getUnreadCount: () =>
    apiClient.get<{ count: number }>('/client-support-chat/seller/unread-count'),

  listSessions: () =>
    apiClient.get<ClientOrderChatSessionsResponse>(
      '/client-support-chat/seller/sessions',
    ),

  getMessages: (
    problemMessageId: number,
    params?: { limit?: number; beforeId?: number },
  ) => {
    const search = new URLSearchParams();
    if (params?.limit != null) search.set('limit', String(params.limit));
    if (params?.beforeId != null) search.set('beforeId', String(params.beforeId));
    const q = search.toString();
    return apiClient.get<ClientOrderChatMessagesResponse>(
      `/client-support-chat/seller/sessions/${problemMessageId}/messages${q ? `?${q}` : ''}`,
    );
  },

  sendMessage: async (
    problemMessageId: number,
    body: string,
    images?: File[],
  ) => {
    const formData = new FormData();
    const trimmed = body.trim();
    if (trimmed) formData.append('body', trimmed);
    if (images && images.length > 0) {
      const compressed = await compressImageFiles(images);
      compressed.forEach((file) => formData.append('images', file));
    }
    return apiClient.post<ClientOrderChatMessage>(
      `/client-support-chat/seller/sessions/${problemMessageId}/messages`,
      formData,
    );
  },

  markRead: (problemMessageId: number) =>
    apiClient.patch<{ ok: boolean; marked: number }>(
      `/client-support-chat/seller/sessions/${problemMessageId}/read`,
      {},
    ),
};
